import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ContractTypeArrayModel,
  ContractTypeModel,
} from "../../models/ContractTypeModel";

const initialContractTypeState: ContractTypeArrayModel = {
  all_ContractTypes: [],
  particular_ContractType: {
    contractTypeId: 0,
    name: "",
    description: "",
    isActive: false,
  },
  isContractTypesFetching: false,
};
const ContractTypeSlice = createSlice({
  name: "ContractType",
  initialState: initialContractTypeState,
  reducers: {
    setContractTypes(state, action: PayloadAction<ContractTypeModel[]>) {
      state.all_ContractTypes = action.payload;
    },
    setParticularContractType(state, action: PayloadAction<ContractTypeModel>) {
      state.particular_ContractType = action.payload;
    },
    setIsContractTypesFetching(state, action: PayloadAction<boolean>) {
      state.isContractTypesFetching = action.payload;
    },
  },
});
export default ContractTypeSlice;
